import { createApp } from 'vue';
import { createHead } from '@unhead/vue/client';
import * as Sentry from '@sentry/vue';
import './style.css';
import App from './App.vue';
import { router } from './router';

const app = createApp(App);
const head = createHead();

app.use(head);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: 1.0,
  sendDefaultPii: true,
});

app.use(router);

app.mount('#app');
